import React from 'react'
import { TripleCustomBreadCrumbs } from '../../components/CustomBreadcrumbs'
import WhitepapersTab from '../../components/WhitepapersTab'
import Navbar from '../../components/Navbar'
import { useTranslation } from 'react-i18next'
import Footer from '../../components/Footer'
import pdf_stamping from "../../assets/images/contents/stamping-pdf.png"
import { StyledLink } from '../../components/StyledComponents'
import filter_color from "../../assets/images/design/colorFilter.svg"

const PDFStampingWhitepaper = () => {
  const { t } = useTranslation()

  return (
    <div className='whitepapers bg-primary'>
      <div className='color-filter-left' style={{ left: "10%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <div className='color-filter-left' style={{ top: "25%" }} >
        <img src={filter_color} alt="" className='img-responsive' />
      </div>
      <Navbar />
      <div className='container-fluid insurance-header pb-100'>
        <div className='container'>
          <div className='col-sm-12 pt-150'>
            <div className='font-weight-bold text-center font-64 insurance-header-title'>{t('whitepapers-tab.pdf-stamping-whitepaper')}</div>
            <div className='col-sm-12'>
              <div className='underline-orange'></div>
            </div>
          </div>
          <div className='col-sm-12 flex justify-center pt-md-100 pt-50 px-0'>
            <TripleCustomBreadCrumbs prevPage={t('bread-crumbs.whitepapers')} currentPage={t('bread-crumbs.pdf-stamping-whitepaper')} linkToPrevPage="/whitepapers" />
          </div>
        </div>
      </div>
      <WhitepapersTab pdfStampingActive={true} />
      <div className="whitepapers-content container pb-100">
        <div className='row'>
          <div className='col-lg-4'>

            <div className="whitepapers-card-mini">
              <StyledLink href="/whitepapers/pdf-stamping">
                <div className='whitepapers-card-mini_image'>
                  <img src={pdf_stamping} alt="" className='img-responsive' />
                </div>
              </StyledLink>
              <div className='case-study-chip mt-20'>
                {t('whitepapers-tab.pdf-stamping-whitepaper')}
              </div>
              <StyledLink href="/whitepapers/pdf-stamping">
                <p className='pt-20 text-white font-20 font-weight-semi-bold'>{t('whitepapers.pdf-stamping-title')}</p>
              </StyledLink>
            </div>

          </div>
        </div>
      </div>

      <Footer />
    </div>
  )
}

export default PDFStampingWhitepaper